export default __webpack_public_path__ + "static/media/img_18.1a67d767.jpg";